var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loading-spinner"},[_c('div',[_c('q-spinner-pie',{attrs:{"color":"primary","size":"3em"}}),_c('q-tooltip',{attrs:{"offset":[0, 8]}},[_vm._v("QSpinnerPie")])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }